import { ApplicationImportIcon } from './ApplicationImportIcon';

/**
 * author: Austin Andrews
 * id 0870BDBC-060F-49E5-B72C-CA06949643AF
 * name application-import
 * version: 3.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/application-import.svg
 * tags
 */
export const IframeImportOutlineIcon = ApplicationImportIcon;
export default IframeImportOutlineIcon